/**
 * Pacing numbers are mirrored on the server for STT→LLM delays:
 * `backend/src/ai/services/conversation-pacing.ts` — keep presets aligned when tuning.
 */
export const CONVERSATION_PACING_VALUES = ["fast", "balanced", "slow"] as const;
export type ConversationPacing = (typeof CONVERSATION_PACING_VALUES)[number];

export const VOICE_INPUT_MODE_VALUES = ["vad", "push_to_talk"] as const;
export type VoiceInputMode = (typeof VOICE_INPUT_MODE_VALUES)[number];

export interface ConversationPacingPreset {
  pauseDurationMs: number;
  twoPhaseInitialMs: number;
  twoPhaseAdditionalMs: number;
  ttsEvictionMs: number;
}

export const CONVERSATION_PACING_PRESETS: Record<
  ConversationPacing,
  ConversationPacingPreset
> = {
  fast: {
    pauseDurationMs: 1250,
    /** Match pause: server waits this long after last STT final before starting the LLM (see TwoPhaseTextBuffer). */
    twoPhaseInitialMs: 1250,
    twoPhaseAdditionalMs: 1000,
    ttsEvictionMs: 400,
  },
  balanced: {
    pauseDurationMs: 3800,
    twoPhaseInitialMs: 3800,
    twoPhaseAdditionalMs: 2200,
    ttsEvictionMs: 750,
  },
  slow: {
    pauseDurationMs: 6200,
    twoPhaseInitialMs: 6200,
    twoPhaseAdditionalMs: 4000,
    ttsEvictionMs: 1400,
  },
};
